import type { JSX, ReactNode } from "react";
import { cx } from "@web/booking/ui";
import { SiteLink } from "@web/site/components/site-link";

const TONES = {
  primary: "bg-primary-600 text-ink-inverse shadow-nav-active hover:bg-primary-700",
  dark: "bg-primary-900 text-ink-inverse shadow-nav-active hover:bg-primary-800",
  outline:
    "border border-primary-300 bg-surface text-primary-700 hover:border-primary-600 hover:bg-primary-50",
  inverse: "bg-surface text-primary-800 shadow-float hover:bg-primary-50",
  "outline-inverse":
    "border border-ink-inverse/60 text-ink-inverse hover:border-ink-inverse hover:bg-ink-inverse/10",
} as const;

export function PillLink({
  to,
  params,
  children,
  tone = "primary",
  size = "md",
  className,
  "data-testid": testId,
}: {
  readonly to: string;
  readonly params?: Record<string, string>;
  readonly children: ReactNode;
  readonly tone?: keyof typeof TONES;
  readonly size?: "md" | "lg";
  readonly className?: string;
  readonly "data-testid"?: string;
}): JSX.Element {
  return (
    <SiteLink
      to={to}
      {...(params && { params })}
      data-testid={testId}
      className={cx(
        "pill-text inline-flex min-h-(--control-h) items-center justify-center gap-2.5 rounded-pill font-medium transition-colors duration-150",
        size === "lg" ? "px-8 text-field" : "px-5 text-label",
        TONES[tone],
        className,
      )}
    >
      {children}
    </SiteLink>
  );
}
